import { Box, IconButton, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import InFlightPanel from '../organisms/InFlightPanel';

const InFlightMonitor = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <IconButton onClick={() => navigate('/returns')} sx={{ mr: 2 }}>
                    <ArrowBack />
                </IconButton>
                <Typography variant="h4" sx={{ fontWeight: 600 }}>
                    In-Flight Messages
                </Typography>
            </Box>

            <InFlightPanel />
        </Box>
    );
};

export default InFlightMonitor;
